import commonConfig from './index.common';

const whiteLabel = process.env.REACT_APP_WHITE_LABEL || 'base';

const specificConfig = require(`./index.${whiteLabel}`).default;
const config = {
    ...commonConfig,
    ...specificConfig
};

export default config;
